import { useGetAccountPayableBillsQuery } from "@apis/accounts/useAccounts"
import { RewardChecksList } from "./RewardChecksList"
import { Loader2 } from "lucide-react"

type Props = { account_id: string }

export const RewardChecks = ({ account_id }: Props) => {
  const {
    data = [],
    isPending,
    isError,
    error,
  } = useGetAccountPayableBillsQuery(account_id)

  if (isPending) {
    return (
      <Loader2 className="tw:h-6 tw:w-6 tw:animate-spin tw:text-gray-500" />
    )
  }

  if (isError) {
    return (
      <div className="tw:text-red-500">
        There was an error loading checks. Error: {error.message}
      </div>
    )
  }
  return <RewardChecksList account_payable_bills={data} />
}
